function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { I18nProvider as Provider, I18n } from './i18nContext';

class I18nProviderWithTranslator extends React.Component {
  constructor(props) {
    super(props);
    const locale = props.locale,
          phrases = props.phrases,
          translator = props.translator;

    if (locale) {
      translator.locale(locale);
    }

    if (phrases) {
      translator.extend(phrases);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.phrases !== this.props.phrases && this.props.phrases) {
      this.props.translator.locale(this.props.locale);
    }
  }

  render() {
    const children = this.props.children;
    return children;
  }

}

const I18nProvider = (_ref) => {
  let translator = _ref.translator,
      restProps = _objectWithoutProperties(_ref, ["translator"]);

  const inner = () => /*#__PURE__*/React.createElement(I18n, null, translator => /*#__PURE__*/React.createElement(I18nProviderWithTranslator, _extends({
    translator: translator
  }, restProps)));

  if (translator) {
    // https://jira.cfops.it/browse/UI-2903
    // Set polyglot's translator locale when signing into a non-English account
    // caused by a race condition between page reloading and API response.
    translator.locale(restProps.locale);
    return /*#__PURE__*/React.createElement(Provider, {
      value: translator
    }, inner());
  } else {
    return inner();
  }
};

export default I18nProvider;